import { NotFound } from 'component/errors/not-found';
import { Catcher } from 'system/catcher';
import { useStructureModule } from 'util/datastore';

export default function ArticleOverlayScreen() {
    const { overlayScreen: OverlayScreen } = useStructureModule().structure;

    if (!OverlayScreen) {
        return <NotFound />;
    }

    return (
        <Catcher>
            <OverlayScreen />
        </Catcher>
    );
}
